import { render, staticRenderFns } from "./completePlan.vue?vue&type=template&id=384f675f&scoped=true&"
import script from "./completePlan.vue?vue&type=script&lang=js&"
export * from "./completePlan.vue?vue&type=script&lang=js&"
import style0 from "./completePlan.vue?vue&type=style&index=0&id=384f675f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384f675f",
  null
  
)

export default component.exports